import { useEffect, useState } from "react";
import { createDefaultPotluck, IConfiguration, IPotluck } from "interfaces";
import { useForm } from "hooks";
import { useApp, useService, useSession } from "contexts";
import { MessageType } from "types";
import { Enums } from "utils";
import { Auxiliars } from "helpers";

export const usePotluck = (initialPotluck: IPotluck, onSubmitCallback?: () => void) => {

  const { user } = useSession();
  const { setFeedback, t } = useApp();
  const { potluckService } = useService();

  const [state, setState] = useState<IPotluck | null>(null);

  const updateCallback = (name: string, value: any) => {
    if (state) {
      setState({ ...state, [name]: value });
    }
  };

  const { onChange, onCustomChange } = useForm({}, undefined, undefined, updateCallback);

  useEffect(() => {
    const updatedState = {
      ...createDefaultPotluck(),
      ...initialPotluck,
    };
    setState(updatedState as any);
  }, [initialPotluck]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!state) return;

    const updatedState = Auxiliars.walkAndReplace<IPotluck>(state, [
      {
        path: "menu.configuration",
        value: (conf: IConfiguration) => conf._id,
      },
      {
        path: "menu.categories.suggested_by",
        override: false,
        value: user.id,
      },
      {
        path: "menu.categories.assigned_to",
        override: false,
        value: user.id,
      }
    ]);

    const response = await potluckService.update(updatedState);
    if (response) {
      setFeedback({ message: t.message.feedback.request_update_success, severity: Enums.EnumFeedback.Success } as MessageType);
      onSubmitCallback?.();
    } else {
      setFeedback({ message: t.message.feedback.request_error, severity: Enums.EnumFeedback.Error } as MessageType);
    }
  };

  return {
    state,
    t,
    onChange,
    onCustomChange,
    handleSubmit,
  };
};
